/* eslint-disable max-len */

import links, { getLinkWithParams } from 'links'

// The Harmonist

import bannerDesktop from '../images/the-harmonist/banner-desktop.jpg'
import bannerMobile from '../images/the-harmonist/banner-mobile.jpg'

import assets0 from '../images/the-harmonist/assets-0.jpg'
import bottomDesktop from '../images/the-harmonist/bottom-desktop.jpg'
import bottomMobile from '../images/the-harmonist/bottom-mobile.jpg'
import heroDesktop from '../images/the-harmonist/hero-desktop.jpg'
import heroMobile from '../images/the-harmonist/hero-mobile.jpg'
import logo from '../images/the-harmonist/logo.svg'
import media0 from '../images/the-harmonist/media-0.jpg'
import missionStatementDesktop from '../images/the-harmonist/mission-statement-desktop.jpg'
import missionStatementMobile from '../images/the-harmonist/mission-statement-mobile.jpg'

import navigationBackground from '../images/the-harmonist/navigation-background.jpg'
import navigationLogo from '../images/the-harmonist/navigation-logo.svg'

import modalHeroDesktop from '../images/the-harmonist/modal-hero-desktop.jpg'
import modalHeroMobile from '../images/the-harmonist/modal-hero-mobile.jpg'


const featuredBrandData: BrandsModule.FeaturedBrandData = {
  bannerData: {
    image: {
      desktop: bannerDesktop,
      mobile: bannerMobile,
    },
    name: 'The Harmonist',
    text: {
      desktop: 'Drawing upon universal truths from both East and West, The Harmonist fragrances\nbring the wearer\'s attention inward, enlightening the journey called life.',
      mobile: 'Drawing upon universal truths from both East and West, The Harmonist fragrances bring the wearer\'s attention inward, enlightening the journey called life, so they can better perceive themselves and the world around them.',
    },
    title: 'The Harmonist',
    to: getLinkWithParams(links.brand, { name: 'the-harmonist' }),
  },
  featuredBrandInfo: {
    assets: [ { url: assets0, type: 'image' } ],
    bottom: {
      image: {
        desktop: bottomDesktop,
        mobile: bottomMobile,
      },
      text: 'When selecting <br class="onlyDesktop" />components for <br class="onlyDesktop" />our fragrances, we <br class="onlyDesktop" />always select top-<br class="onlyDesktop" />quality ingredients <br class="onlyDesktop" />that accentuate <br class="onlyDesktop" />the power of <br class="onlyDesktop" />nature\'s primordial <br class="onlyDesktop" />elements.',
      textStyle: {
        desktop: 'h3',
        mobile: 'h5',
      },
    },
    country: 'Paris/Los Angeles',
    description: 'At the Harmonist, balance begins with harmony. To find balance in one’s self, our inner character must act in harmony with our persona. To find balance in life, we must act in harmony with our surroundings. Harmony is both intricate and effortless, the product of complexity rather than a simple binary.<br /><br />To achieve harmony in everything from our signature scents to our stores, we draw upon the principles of Feng Shui, its respect of energy and flow, the charcter that comes from duality, and the strength that comes from interconnection.',
    groupFragrances: true,
    hero: {
      desktop: heroDesktop,
      mobile: heroMobile,
    },
    logo: logo,
    medias: [ { url: media0, type: 'image' } ],
    missionStatement: {
      image: {
        desktop: missionStatementDesktop,
        mobile: missionStatementMobile,
      },
      text: 'All The Harmonist products are made from ethically sourced ingredients, that enlighten the wearer, allowing you to be who you truly are. Enclosed in comfort and encased in natures morning mists and dews.',
    },
    productIds: [ 1805, 1933, 2279, 1946, 2326, 1932, 2156 ],
    quote: {
      authorName: 'Lola Tillyaeva',
      authorPosition: 'Perfumer',
      supTitle: 'Find your inner harmony',
      text: 'At The Harmonist, we support people to find inner and outer harmony, understand their unique qualities and create self-care rituals that empower and bring balance through scent.',
    },
    year: 0,
  },
  modalData: {
    image: {
      desktop: modalHeroDesktop,
      mobile: modalHeroMobile,
    },
    name: 'The Harmonist',
    productIds: {
      FEMALE: [ '1805', '2279', '1946', '2326', '1933' ],
      MALE: [ '1932', '2156', '1933', '2279', '1805' ],
    },
    text: {
      desktop: '',
      mobile: 'The Harmonist fragrances bring the wearer\'s attention inward, enlightening the journey called life.',
    },
    to: getLinkWithParams(links.brand, { name: 'the-harmonist' }),
  },
  modalOptions: {
    genders: [ 'FEMALE', 'MALE' ],
  },
  navigationBannerData: {
    background: navigationBackground,
    logo: navigationLogo,
    name: 'The Harmonist',
    text: 'Drawing upon universal truths from both East\nand West, The Harmonist fragrances bring the\nwearer\'s attention inward, enlightening the\njourney called life, so they can better perceive\nthemselves, as well as the world around them.',
    to: getLinkWithParams(links.brand, { name: 'the-harmonist' }),
  },
}

export default featuredBrandData
